import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerCompositeTranslations } from "./i18n";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution, type CompositeSolution } from "./solution";
import type { CompositeDefinition, CompositeProgress, CompositeSubmission } from "./types";

registerCompositeTranslations(i18n);

/** No `localFeedback`: the backend declares `live_feedback: false` for this type. */
export const compositeModule: PuzzleTypeModule<
  CompositeDefinition,
  CompositeSubmission,
  CompositeProgress,
  CompositeSolution
> = {
  key: "composite",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
};
